export var TableRowRole;
(function (TableRowRole) {
    TableRowRole["GROUP_HEADER"] = "GROUP_HEADER";
    TableRowRole["GROUP_ELEMENT"] = "GROUP_ELEMENT";
    TableRowRole["SPACER"] = "SPACER";
    TableRowRole["DEFAULT"] = "DEFAULT";
})(TableRowRole || (TableRowRole = {}));
